import * as yup from "yup";

import * as MESSAGES from "../messages";

export const editModelSchema = yup.object().shape({
  name: yup.string().required(MESSAGES.REQUIRE_MESSAGE).trim(),
});
